// client/src/pages/Game/Battlefield/components/DeckDisplay.jsx

import React, { useMemo } from 'react';
import { cardBackUrl } from '../../../../api/cardBackService';

/**
 * Affiche le deck d'un joueur. Position et taille en pourcentages du frame.
 * Dos de carte : un seul dos actif par joueur (cosmétique profil) —
 * le sien via gameState.playerCardBack, celui de l'adversaire via
 * gameState.opponentCardBack (transmis par le serveur). Fallback neutre.
 */
const DeckDisplay = ({
  player,
  gameState,
  position,
  size,
  onDevDragStart,
  devMode,
  onGraveyardOpen,
}) => {
  const backUrl = useMemo(() => {
    const id = player === 'player'
      ? (gameState?.playerCardBack || 'neutral')
      : (gameState?.opponentCardBack || 'neutral');
    return cardBackUrl(id);
  }, [player, gameState?.playerCardBack, gameState?.opponentCardBack]);

  if (!gameState) return null;

  const deckCount = player === 'player'
    ? (gameState.playerDeck ? gameState.playerDeck.length : 0)
    : (gameState.opponentDeckCount !== undefined
        ? gameState.opponentDeckCount
        : (gameState.opponentDeck ? gameState.opponentDeck.length : 0));

  const graveyard = player === 'player'
    ? (gameState.playerGraveyard || []).length
    : (gameState.opponentGraveyard || []).length;

  const handleDevDrag = (e) => {
    if (devMode && onDevDragStart) onDevDragStart(e);
  };

  return (
    <div
      className={`game-element deck-area ${player}-deck`}
      style={{
        left: `${position.x}%`,
        top: `${position.y}%`,
        width: `${size.width}cqw`,
        height: `${size.height}cqw`,
        transform: 'translate(-50%, -50%)',
        cursor: devMode ? 'move' : 'default',
      cursor: devMode ? 'move' : (onGraveyardOpen ? 'pointer' : 'default'),
      }}
      data-graveyard={player}
      onClick={(e) => {
        if (!devMode && onGraveyardOpen) {
          e.stopPropagation();
          onGraveyardOpen();
        }
      }}
      onMouseDown={devMode ? handleDevDrag : undefined}
      onTouchStart={devMode ? handleDevDrag : undefined}
      title={`Deck (${deckCount} cartes) — cliquer pour consulter le cimetière (${graveyard} cartes)`}
    >
      <div className="deck-card" style={{
        width: '100%',
        height: '100%',
        position: 'relative',
        borderRadius: '0.5cqw',
        backgroundImage: `linear-gradient(rgba(10,18,35,0.25), rgba(10,18,35,0.25)), url("${backUrl}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
        <span className="deck-card-counter" style={{
          position: 'absolute',
          bottom: '0.4cqw',
          right: '0.7cqw',
          color: 'white',
          fontSize: 'calc(1cqw * var(--font-scale, 1) * var(--fs-deck, 1))',
          fontWeight: 'bold',
          textShadow: '0 0 0.2cqw black, 0 0 0.4cqw black',
        }}>
          {deckCount}
        </span>
        {graveyard > 0 && (
          <span className="deck-graveyard-badge" style={{
            position: 'absolute',
            top: '0.3cqw',
            left: '0.5cqw',
            color: 'rgba(220, 200, 255, 0.95)',
            fontSize: 'calc(0.8cqw * var(--font-scale, 1) * var(--fs-deck, 1))',
            fontWeight: 'bold',
            textShadow: '0 0 0.2cqw black, 0 0 0.4cqw black',
          }}>
            ☠ {graveyard}
          </span>
        )}
      </div>
    </div>
  );
};

export default DeckDisplay;
